import mutation from './mutation.graphql.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api'
import {
  notifyError,
  notifyInvalid,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import { useDataValue } from 'Simple/Data.js'
import { textAtLeastOneChar } from 'Simple/Data/validate.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)
  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'id',
  })

  let [, executeMutation] = useMutation(mutation)
  return async function onSubmit({ value, originalValue, args, change }) {
    if (isInvalid(value, notify)) return true

    let mutationResponse = await executeMutation({
      access_key_encoded: btoa(value.access_key),
      account_id: value.account_id,
      location_id,
      provider: value.provider,
      is_default: value.is_default,
    })

    if (mutationResponse.error) {
      notify(
        notifyError(
          'Something went wrong. Please, try again or contact support if the problem persists.'
        )
      )
      return
    }

    notify(notifySuccess('Payment provider added!'))
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}

let PROVIDERS = ['bluefin', 'payabli']
function isInvalid(value, notify) {
  let list = [
    !PROVIDERS.includes(value.provider) && 'provider',
    !textAtLeastOneChar(value.account_id) && 'account ID',
    !textAtLeastOneChar(value.access_key) && 'access key',
  ].filter(Boolean)

  if (list.length > 0) {
    notify(notifyInvalid(list))
    return true
  }
  return false
}
